export type EnvBar = { color: string; label: string };

const STAGING_COLOR = "#f59e0b"; // amber-400
const LOCAL_COLOR = "#8b5cf6"; // violet-500

// production shows nothing; staging amber; anything else violet
export function resolveEnvBar(env: string | undefined): EnvBar | null {
  const name = env || "local";
  if (name === "production") return null;
  if (name === "staging") return { color: STAGING_COLOR, label: "staging" };
  return { color: LOCAL_COLOR, label: name };
}
